<i-title styleClass="w-100" [text]="'modals.duplicateMail' | translate" [buttons]="titleButtons" level="1"></i-title>

<div class="modal-body mt-4">
  <div class="row" [formGroup]="formDuplicate">
    <div class="col-md-12 alert alert-info">
      <span class="super-compos-label-input">{{ 'modals.onDuplicationGeneralDatasAndClassificationsAreDuplicatedAutomatically' | translate }}</span>
    </div>

    <div class="col-md-12">
      <span class="super-compos-label-input">{{ 'modals.duplicateEverything' | translate }}</span>
      <p-inputSwitch [formControlName]="'all'" (onChange)="checkAll($event)"></p-inputSwitch>
    </div>

    <div class="col-md-4 mb-3 p-fluid">
      <span class="super-compos-label-input">{{ 'modals.duplicateFiles' | translate }}</span>
      <p-inputSwitch formControlName="files" (onChange)="unCheckTheAllControl($event)"></p-inputSwitch>
    </div>

    <div class="col-md-4 mb-3 p-fluid">
      <span class="super-compos-label-input">{{ 'modals.duplicateRecipients' | translate }}</span>
      <p-inputSwitch formControlName="destinataires" (onChange)="unCheckTheAllControl($event)"></p-inputSwitch>
    </div>

    <div class="col-md-4 mb-3 p-fluid">
      <span class="super-compos-label-input">{{ 'modals.duplicateLinks' | translate }}</span>
      <p-inputSwitch formControlName="links" (onChange)="unCheckTheAllControl($event)"></p-inputSwitch>
    </div>
  </div>
</div>
